// extracted by mini-css-extract-plugin
export default {"jobList":"JobList_jobList__mkPiM","jobListHeader":"JobList_jobListHeader__WbUZv","jobListTitle":"JobList_jobListTitle__HJszh"};